export default __webpack_public_path__ + "static/media/starBlank_large.1d55660a.svg";